import { StyleSheet, Platform, Dimensions } from 'react-native';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 20,
    paddingVertical: 13,
    paddingHorizontal: 16,
    marginHorizontal: 2,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  secondCardContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  arrowIcon: {
    marginRight: 2,
    'justify-self': 'flex-end'
  },
  text: {
    flex: 1,
  },
  topText: {
    fontSize: 18.7,
    lineHeight: 25,
    fontWeight: 700
  },
  secondText: {
    fontSize: 16,
    lineHeight: 22.9,
    marginTop: 10,
  },
  leftIcon: {
    marginLeft: 1,
    marginRight: 16,
  },
  badgeStyle: {
    width: '30%',
  },
  badgeTextStyle: {
    textAlign: 'center',
    paddingVertical: 1,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  },
});
